// Generated by CoffeeScript 2.7.0
var Day;

export default Day = {
  props: {
    displayRange: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  template: `<div class="day-picker-view">
  <div class="days-nav justify-between">
    <div class="day-col offday">周日</div>
    <div class="day-col workday">周一</div>
    <div class="day-col workday">周二</div>
    <div class="day-col workday">周三</div>
    <div class="day-col workday">周四</div>
    <div class="day-col workday">周五</div>
    <div class="day-col offday">周六</div>
  </div>
  <div class="picker-view">
    <div class="picker-row" v-for='(week, index) in displayRange' :key='index'>
      <div class="picker-item" v-for='day in week'
            :key='day.key'
            :class="computeItemClass(day)"
            @click='update(day)'>
        <div class="picker-value">{{ day.text }}</div>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    update: function(day) {
      return this.$emit('update', day);
    },
    computeItemClass: function(day) {
      return [
        day.status,
        {
          active: this.initValue.strftime('YYYY-MM-DD') === day.key
        }
      ];
    }
  }
};
